import { atom } from "recoil"

export const contactReadStatusRequestIdState = atom<number>({
  key: "atoms/contact/contactReadStatusRequestIdState",
  default: 0,
})
